import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cinema, Showtime } from '../models';
import { API_BASE, params } from './api';

@Injectable({ providedIn: 'root' })
export class CinemaService {
  constructor(private readonly http: HttpClient) {}

  list(filters: { county?: string; chain?: string } = {}) {
    return this.http.get<Cinema[]>(`${API_BASE}/cinemas${params(filters)}`);
  }

  get(id: string) {
    return this.http.get<Cinema>(`${API_BASE}/cinemas/${id}`);
  }

  showtimes(id: string, filters: { date?: string } = {}) {
    return this.http.get<Showtime[]>(`${API_BASE}/cinemas/${id}/showtimes${params(filters)}`);
  }
}
